import React, { useState, useEffect } from 'react';

export const InfoPanel = ({ currentVideo, videoIndex, totalVideos, isAnimated }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    });
  };

  return (
    <div className="info-panel fade-in" style={{ animationDelay: '0.5s' }}>
      <div className="info-card">
        <div className="info-card-title">Time</div>
        <div className="info-card-value">{formatTime(currentTime)}</div>
      </div>
      
      {!isAnimated && totalVideos > 1 && (
        <div className="info-card">
          <div className="info-card-title">Scene</div>
          <div className="info-card-value">{videoIndex}/{totalVideos}</div>
        </div>
      )}
      
      <div className="info-card scene-name">
        <div className="info-card-title">{isAnimated ? 'Mode' : 'Now Playing'}</div>
        <div className="info-card-value-small">{currentVideo}</div>
      </div>
    </div>
  );
};
